import {
  SHSRMenu,
  SMSMenu,
  SNTMenu,
  SOAMenu,
  SREEMenu,
  SSITMenu,
} from "../components/Layout/DepartmentMenu";
import { JNTUK_API_Urls } from "./api.config";
const currentDate = new Date();
const formattedDate = currentDate.toISOString();
const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
export const getPageTitle = () => {
  if (currentDomain === "shsr") return "School of Health Sciences and Research";
  else if (currentDomain === "sree")
    return "School of Renewable Energy & Environment";
  else if (currentDomain === "soa") return "School of Avionics";
  else if (currentDomain === "ssit")
    return "School of Spatial Information Technology";
  else if (currentDomain === "snt") return "School of Nano Technology";
  else if (currentDomain === "sms") return "School of Management Studies";
  else if (currentDomain === "sopst")
    return "School of Pharmaceutical Sciences & Technologies";
  else return null;
};
export const getAPIPath = () => {
  if (currentDomain === "shsr")
    return {
      home: JNTUK_API_Urls["School-SHSR-Home"],
      profile:
        "/school-shsr-faculties?filters[Designation][$contains]=Head of the Department&populate=*",
      gallery: JNTUK_API_Urls["School-SHSR-Gallery"],
      contact: JNTUK_API_Urls["School-SHSR-Contact-Us"],
      home_slider: `school-shsr-home-page-banners?populate=*&filters[End_Time][$gte]=${formattedDate}`,
      faculties: JNTUK_API_Urls["School-SHSR-Faculties"],
    };
  else if (currentDomain === "sree")
    return {
      home: JNTUK_API_Urls["School-SREE-Home"],
      home_slider: `school-sree-home-page-banners?populate=*&filters[End_Time][$gte]=${formattedDate}`,
      profile:
        "/school-sree-faculties?filters[Designation][$contains]=Programme Director&populate=*",
      gallery: JNTUK_API_Urls["School-SREE-Gallery"],
      contact: JNTUK_API_Urls["School-SREE-Contact-Us"],
      infra_structure: JNTUK_API_Urls["School-SREE-Infra-Structure"],
      faculties: JNTUK_API_Urls["School-SREE-Faculties"],
      companiesList: JNTUK_API_Urls["SREE_Industry_Interaction"],
      placements: JNTUK_API_Urls["SREE_Placements"],
      about_course: JNTUK_API_Urls["School-SREE-About-Course"],
      eligibility: JNTUK_API_Urls["School-SREE-Eligibility"],
      syllabus: JNTUK_API_Urls["School-SREE-Syllabus"],
      course_structure: JNTUK_API_Urls["School-SREE-Course-Structure"],
      research_publications: JNTUK_API_Urls["School-SREE-Research-Publication"],
    };
  else if (currentDomain === "soa")
    return {
      home: JNTUK_API_Urls["School-SOA-Home"],
      home_slider: `school-soa-home-page-banners?populate=*&filters[End_Time][$gte]=${formattedDate}`,
      profile:
        "/school-soa-faculties?filters[Designation][$contains]=Head of the Department&populate=*",
      faculties: JNTUK_API_Urls["School-SOA-Faculties"],
      gallery: JNTUK_API_Urls["School-SOA-Gallery"],
      contact: JNTUK_API_Urls["School-SOA-Contact-Us"],
      about_course: JNTUK_API_Urls["School-SOA-About-Course"],
      eligibility: JNTUK_API_Urls["School-SOA-Eligibility"],
      syllabus: JNTUK_API_Urls["School-SOA-Syllabus"],
      infra_structure: JNTUK_API_Urls["School-SOA-Infra-Structure"],
      bos: JNTUK_API_Urls["School-SOA-Bos"],
      research_publications: JNTUK_API_Urls["School-SOA-Research-Publication"],
      mous_signed: JNTUK_API_Urls["School-SOA-MOU-Signed"],
      internship_opportunities:
        JNTUK_API_Urls["School-SOA-Internship-Opportunitie"],
      campus_placements: JNTUK_API_Urls["School-SOA-Campus-Placements"],
    };
  else if (currentDomain === "ssit")
    return {
      home: JNTUK_API_Urls["School-SSIT-Home"],
      home_slider: `school-ssit-home-page-banners?populate=*&filters[End_Time][$gte]=${formattedDate}`,
      profile:
        "/school-ssit-faculties?filters[Designation][$contains]=Head of the Department&populate=*",
      about: JNTUK_API_Urls["School-SSIT-About-Us"],
      contact: JNTUK_API_Urls["School-SSIT-Contact-Us"],
      infra_structure: JNTUK_API_Urls["School-SSIT-Infra-Structure"],
      Infrastructure_Equipment:JNTUK_API_Urls["School-SSIT-Equipment"],
      faculties: JNTUK_API_Urls["School-SSIT-Faculties"],
      facultyDescription:
        JNTUK_API_Urls["School-SSIT-Faculty-Recharging-Strategies"],
      eligibility: JNTUK_API_Urls["School-SSIT-Eligibility"],
      course_structure: JNTUK_API_Urls["School-SSIT-Course-Structure"],
      syllabus: JNTUK_API_Urls["School-SSIT-Syllabus"],
      vision_and_mission: JNTUK_API_Urls["School-SSIT-Vision-and-Mission"],
      about_course: JNTUK_API_Urls["School-SSIT-M.Tech-Remote-Sensing"],
      academic_calendar: JNTUK_API_Urls["School-SSIT-Academic-Calendar"],
      timetables: JNTUK_API_Urls["School-SSIT-Timetables"],
      case_study_focus: JNTUK_API_Urls["School-SSIT-Case-Study-Focus"],
      SSIT_Advantage: JNTUK_API_Urls["School-SSIT-Advantage"],
      bos: JNTUK_API_Urls["School-SSIT-BOS"],
      Research_Scholars: JNTUK_API_Urls["School-SSIT-Research-Scholars"],
      Research_Publications_Boook_Chapter:
        JNTUK_API_Urls["School-SSIT-Book-Chapter-Research-Publications"],
      Research_Publications_Journal_Conference:
        JNTUK_API_Urls["School-SSIT-Journal/Conference-Publication"],
      Particulars_of_Research_scholars:
        JNTUK_API_Urls["School-SSIT-Particulars-of-Research-scholars"],
      Workshop_Conference: JNTUK_API_Urls["Workshop/Conference"],
      gallery: JNTUK_API_Urls["School-SSIT-Gallery"],
      Downloads: JNTUK_API_Urls["Downloads"],
    };
  else if (currentDomain === "snt")
    return {
      home: JNTUK_API_Urls["School-SNT-Home"],
      home_slider: `school-snt-home-page-banners?populate=*&filters[End_Time][$gte]=${formattedDate}`,
      profile:
        "/school-snt-faculties?filters[Designation][$contains]=Head of the Department&populate=*",
      profile2:
        "/school-snt-faculties?filters[Designation][$contains]=Academic Advisor&populate=*",
      gallery: JNTUK_API_Urls["School-SNT-Gallery"],
      contact: JNTUK_API_Urls["School-SNT-Contact-Us"],
      infra_structure: JNTUK_API_Urls["School-SNT-Infra-Structure"],
      faculties: JNTUK_API_Urls["School-SNT-Faculties"],
      industry_interaction: JNTUK_API_Urls["School-SNT-Industry-Interaction"],
      placements: JNTUK_API_Urls["School-SNT-Placements"],
      about_course: JNTUK_API_Urls["School-SNT-About-Course"],
      eligibility: JNTUK_API_Urls["School-SNT-Eligibility"],
      syllabus: JNTUK_API_Urls["School-SNT-Syllabus"],
      bos: JNTUK_API_Urls["School-SNT-BOS"],
      course_structure: JNTUK_API_Urls["School-SNT-Course-Structure"],
      academic_calendar: JNTUK_API_Urls["School-SNT-Academic-Calendar"],
      timetables: JNTUK_API_Urls["School-SNT-Timetables"],
      research_publications:
        JNTUK_API_Urls["School-SNT-Research-and-Publications"],
      notifications_tenders:
        JNTUK_API_Urls["School-SNT-Notifications-and-Tenders"],
      project_opportunities: JNTUK_API_Urls["School-SNT-Project-Opportunities"],
      sports_activity: JNTUK_API_Urls["School-SNT-Sports-Activity"],
      achievements: JNTUK_API_Urls["School-SNT-Achievements"],
      student_activities: JNTUK_API_Urls["School-SNT-Student-Activities"],
      details_of_papers:
        JNTUK_API_Urls["School-SNT-Papers-presented-in-Conferences"],
      campus_placements: JNTUK_API_Urls["School-SNT-Campus-Placements"],
    };
  else if (currentDomain === "sms")
    return {
      home: JNTUK_API_Urls["School-SMS-Home"],
      home_slider: `school-sms-home-page-banners?populate=*&filters[End_Time][$gte]=${formattedDate}`,
      profile:
        "/school-sms-faculties?filters[Designation][$contains]=Director&populate=*",
      programs: JNTUK_API_Urls["School-SMS-Programs"],
      course_structure: JNTUK_API_Urls["School-SMS-Course-Structure"],
      gallery: JNTUK_API_Urls["School-SMS-Alumni"],
      contact: JNTUK_API_Urls["School-SMS-Contact-Us"],
      infra_structure: JNTUK_API_Urls["School-SMS-Infra-Structure"],
      faculties: JNTUK_API_Urls["School-SMS-Faculties"],
      placements: JNTUK_API_Urls["School-SMS-Placements"],
      about_course: JNTUK_API_Urls["School-SMS-About-Course"],
      eligibility: JNTUK_API_Urls["School-SMS-Eligibility"],
      syllabus: JNTUK_API_Urls["School-SMS-Syllabus"],
      research_publications:
        JNTUK_API_Urls["School-SMS-Research-and-Publications"],
      notifications: JNTUK_API_Urls["School-SMS-Notifications"],
      achivements: JNTUK_API_Urls["School-SMS-Achivements"],
      event_attended: JNTUK_API_Urls["School-SMS-EVENTS-ATTENDED"],
      forthcoming_events: JNTUK_API_Urls["School-SMS-Forthcoming-Events"],
      past_events: JNTUK_API_Urls["School-SMS-Past-Events"],
    };
  else if (currentDomain === "sopst") {
    return {
      home: JNTUK_API_Urls["School-SOPST-Home"],
      home_slider: `/school-sopst-home-page-banners?populate=*&filters[End_Time][$gte]=${formattedDate}`,
      profile:
        "/school-sopst-faculties?filters[Designation][$contains]=Special officer&populate=*",
    };
  } else return null;
};

export const getMenu = () => {
  if (currentDomain === "shsr") return <SHSRMenu />;
  else if (currentDomain === "sree") return <SREEMenu />;
  else if (currentDomain === "soa") return <SOAMenu />;
  else if (currentDomain === "ssit") return <SSITMenu />;
  else if (currentDomain === "snt") return <SNTMenu />;
  else if (currentDomain === "sms") return <SMSMenu />;
  else return null;
};
